import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";
import { createCAItem } from "@/stores/EngineStore/helpers/createCAItem.ts";

export const addCartItemHelper = (state: EngineStoreData, ratePlan: RatePlanMerged) => {
  const maxCapacity =
    (ratePlan.rateGroup.guestCapacity ?? 0) + (ratePlan.rateGroup.guestAdditionalCapacity ?? 0);
  const adultsCount = maxCapacity <= 1 ? 1 : 2;

  return {
    ...state,
    cartAccommodationItems: [
      ...state.cartAccommodationItems,
      createCAItem(ratePlan, adultsCount, state.defaultDateRange),
    ],
  };
};
